export const validateStep = (step, formData, qualificationDocs = {}) => {
  const errors = {};

  switch (step) {
    case 0: // PPP Verification
     
      if (!formData.pppId) {
        errors.pppId = 'PPP ID is required';
      }
      if (!formData.memberId) {
        errors.memberId = 'Please select a family member and complete verification';
      }
      break;

    case 1: // Family Details
      if (!formData.fullName?.trim()) {
        errors.fullName = 'Full name is required';
      }
      if (!formData.fatherName?.trim()) {
        errors.fatherName = 'Father\'s name is required';
      }
      if (!formData.motherName?.trim()) {
        errors.motherName = 'Mother\'s name is required';
      }
      if (!formData.dob) {
        errors.dob = 'Date of birth is required';
      } else {
        const dob = new Date(formData.dob);
        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
          age--;
        }
        
        if (age < 18) {
          errors.dob = 'You must be at least 18 years old';
        }
      }
      if (!formData.gender) {
        errors.gender = 'Gender is required';
      }
      if (!formData.maritalStatus) {
        errors.maritalStatus = 'Marital status is required';
      }
      break;

    case 2: // Address Details
      if (!formData.state) {
        errors.state = 'State is required';
      }
      if (!formData.district) {
        errors.district = 'District is required';
      }
      if (!formData.tehsil) {
        errors.tehsil = 'Tehsil is required';
      }
      if (!formData.village?.trim()) {
        errors.village = 'Village/Ward/Colony is required';
      }
      if (!formData.address?.trim()) {
        errors.address = 'Address is required';
      }
      if (!formData.pinCode) {
        errors.pinCode = 'PIN code is required';
      } else if (!/^\d{6}$/.test(formData.pinCode)) {
        errors.pinCode = 'PIN code must be 6 digits';
      }
      break;

    case 3: // Contact Information
      if (!formData.email) {
        errors.email = 'Email is required';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        errors.email = 'Please enter a valid email address';
      }
      if (!formData.mobile) {
        errors.mobile = 'Mobile number is required';
      } else if (!/^\d{10}$/.test(formData.mobile)) {
        errors.mobile = 'Please enter a valid 10-digit mobile number';
      }
      if (formData.altMobile && !/^\d{10}$/.test(formData.altMobile)) {
        errors.altMobile = 'Please enter a valid 10-digit alternate mobile number';
      }
      break;

    case 4: // Educational & Military Details
      // Define required educational qualifications
      const requiredQualifications = ["8th", "10th", "12th", "Graduation"];
      
      // Validate each required qualification
      requiredQualifications.forEach(qualification => {
        if (!formData[`boardUniversity_${qualification}`]?.trim()) {
          errors[`boardUniversity_${qualification}`] = `Board/University for ${qualification} is required`;
        }
        if (!formData[`instituteName_${qualification}`]?.trim()) {
          errors[`instituteName_${qualification}`] = `Institute name for ${qualification} is required`;
        }
        if (!formData[`gradePercentage_${qualification}`]?.trim()) {
          errors[`gradePercentage_${qualification}`] = `Grade/Percentage for ${qualification} is required`;
        } else if (!/^\d+(\.\d+)?%?$/.test(formData[`gradePercentage_${qualification}`].trim())) {
          errors[`gradePercentage_${qualification}`] = `Please enter a valid percentage for ${qualification}`;
        }
        
        // Check if document is uploaded for required qualifications
        const hasDocument = qualificationDocs[qualification] || formData[`document_${qualification}`] || formData[`document_${qualification}_file`];
        if (!hasDocument) {
          errors[`document_${qualification}`] = `Document for ${qualification} is required`;
        }
      });
      
      // Optional: Validate professional course if any field is filled
      const professionalCourse = "Professional Course (if any)";
      const hasProfessionalCourse = [
        formData[`boardUniversity_${professionalCourse}`]?.trim(),
        formData[`instituteName_${professionalCourse}`]?.trim(),
        formData[`gradePercentage_${professionalCourse}`]?.trim()
      ].some(Boolean);
      
      if (hasProfessionalCourse) {
        if (!formData[`boardUniversity_${professionalCourse}`]?.trim()) {
          errors[`boardUniversity_${professionalCourse}`] = 'Board/University is required for Professional Course';
        }
        if (!formData[`instituteName_${professionalCourse}`]?.trim()) {
          errors[`instituteName_${professionalCourse}`] = 'Institute name is required for Professional Course';
        }
        if (!formData[`gradePercentage_${professionalCourse}`]?.trim()) {
          errors[`gradePercentage_${professionalCourse}`] = 'Grade/Percentage is required for Professional Course';
        } else if (!/^\d+(\.\d+)?%?$/.test(formData[`gradePercentage_${professionalCourse}`].trim())) {
          errors[`gradePercentage_${professionalCourse}`] = 'Please enter a valid percentage for Professional Course';
        }
        
        // Check if document is uploaded for professional course if any field is filled
        const hasDocument = qualificationDocs[professionalCourse] || formData[`document_${professionalCourse}`] || formData[`document_${professionalCourse}_file`];
        if (!hasDocument) {
          errors[`document_${professionalCourse}`] = 'Document for Professional Course is required';
        }
      }
            const hasMilitaryDetails = 
        formData.militaryEnrollmentDate || 
        formData.militaryDischargeDate || 
        formData.militaryCourse?.trim() || 
        formData.militaryCourseDocument;
      if (hasMilitaryDetails) {
      
      if (!formData.militaryEnrollmentDate) {
          errors.militaryEnrollmentDate = 'Enrollment date is required';
        }
        if (!formData.militaryDischargeDate) {
          errors.militaryDischargeDate = 'Discharge date is required';
        } else if (formData.militaryEnrollmentDate && new Date(formData.militaryDischargeDate) <= new Date(formData.militaryEnrollmentDate)) {
          errors.militaryDischargeDate = 'Discharge date must be after enrollment date';
        }
        if (!formData.militaryCourse?.trim()) {
          errors.militaryCourse = 'Course name is required';
        }
        if (!formData.militaryCourseDocument) {
          errors.militaryCourseDocument = 'Course certificate is required';
        }
      }
      break;

    case 5: // NSQF Course Selection
      if (!formData.nsqfCourseId) {
        errors.nsqfCourseId = 'Please select a course';
      }
      break;

    default:
      break;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};
